import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { EpButtonType, EpButtonStyle } from '@epicor/kinetic';
import { ReportServerQueueItemStatus, CheckoutResults } from 'ep-bt-field-agent-proxy';
import { SalesOrderObjectType, SendPaymentLinkResult, ErrorStatus } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaQuickOrderSummaryService } from '../../services/epbt-fa-quick-order-summary.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-email',
  templateUrl: './epbt-fa-quick-order-email.component.html',
  styleUrls: ['./epbt-fa-quick-order-email.component.scss']
})
export class EpbtFaQuickOrderEmailComponent implements OnInit {

  EpButtonType = EpButtonType;
  EpButtonStyle = EpButtonStyle;
  emailForm: FormGroup;
  submitted = false;
  @Input() orderObjectType: number;

  emailEditingPanel = true;
  infoPanel = false;
  lblResult = '';

  constructor(private formBuilder: FormBuilder, private location: Location,
    public quickOrderService: EpbtFaQuickOrderService,
    private quickOrderSummaryService: EpbtFaQuickOrderSummaryService,
    private faService: EpbtFieldAgentService, private router: Router) { }
  // ^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$
  ngOnInit() {
    this.emailForm = this.formBuilder.group({
      // fromEmail: [this.quickOrderSummaryService.getTransactionNotificationFromAddress(), [Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-\\.]+)\\.([a-zA-Z]{2,5})$')]],
      fromEmail: [this.quickOrderSummaryService.getTransactionNotificationFromAddress()],
      toEmail: [this.quickOrderSummaryService.getEmailTo(), [Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-\\.]+)\\.([a-zA-Z]{2,5})$')]],
      subject: [this.quickOrderSummaryService.emailTemplate.subject, Validators.required],
      text: [this.quickOrderSummaryService.getBody(), Validators.required]
    });

    this.emailEditingPanel = true;
    this.quickOrderSummaryService.emailButtonFlag = true;
    this.infoPanel = false;
  }

  // This will be use in html code for validation
  get frmFields() { return this.emailForm.controls; }

  // Bind the existing values
  bindValuesToForm() {
    this.emailForm.patchValue({
      fromEmail: this.quickOrderSummaryService.getTransactionNotificationFromAddress(),
      toEmail: this.quickOrderSummaryService.getEmailTo(),
      subject: this.quickOrderSummaryService.emailTemplate.subject,
      text: this.quickOrderSummaryService.getBody()
    });
  }

  onSendEmail() {
    this.submitted = true;
    if (this.emailForm.valid) {
      this.quickOrderSummaryService.emailTemplate.body = this.emailForm.controls['text'].value;
      this.quickOrderSummaryService.emailTemplate.subject = this.emailForm.controls['subject'].value;
      const toEmail = this.emailForm.controls['toEmail'].value;
      const messageStatus = this.orderObjectType == SalesOrderObjectType.SalesOrder ? ReportServerQueueItemStatus.NotProcessed : ReportServerQueueItemStatus.Delayed;
      this.quickOrderSummaryService.sendPaymentRequest(toEmail, this.quickOrderSummaryService.emailTemplate, messageStatus, (sendResult: any) => {
        if (this.orderObjectType == SalesOrderObjectType.SalesOrder) {
          this.emailEditingPanel = false;
          this.quickOrderSummaryService.emailButtonFlag = false;
          this.infoPanel = true;
          this.lblResult = this.quickOrderSummaryService.getSendLinkResultDescription(sendResult);
        } else {
          if (sendResult == SendPaymentLinkResult.Success) {
            this.quickOrderSummaryService.generateWebTrackOrder((result: CheckoutResults) => {
              if (result && result.success) {
                this.faService.displayToastMessage('Success', 'Reference Number: ' + result.bisTrackReference, ErrorStatus.Success);
                this.router.navigate(['/home']);
              } else {
                this.faService.displayToastMessage('Error', 'Something went worng', ErrorStatus.Error);
              }
            });
          } else {
            // TODO :
            // either delete e-mail from the queue here because quick order was not submitted
            // or
            // implement web service with transaction: 1) send e-mail 2) submit the order
          }
        }
      });
    } else {
      return;
    }
  }
}

